var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconRejoinLive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 9,
    viewBox: "0 0 12 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.31738 8.17578C6.45898 8.17578 6.59082 8.12207 6.70801 8.00977L9.92578 4.79199C10.0283 4.69922 10.0869 4.57227 10.1016 4.43555V7.65332C10.1016 7.95605 10.3311 8.17578 10.6338 8.17578C10.9414 8.17578 11.1709 7.95605 11.1709 7.65332V1.12988C11.1709 0.827148 10.9414 0.602539 10.6338 0.602539C10.3311 0.602539 10.1016 0.827148 10.1016 1.12988V4.34277C10.0869 4.21094 10.0283 4.08398 9.92578 3.98633L6.70801 0.768555C6.59082 0.65625 6.45898 0.602539 6.31738 0.602539C6.00977 0.602539 5.78516 0.822266 5.78516 1.12012C5.78516 1.27637 5.84863 1.4082 5.94629 1.50586L7.04492 2.61914L8.46094 3.88867L7.40625 3.84473H1.37598C1.04883 3.84473 0.824219 4.06934 0.824219 4.3916C0.824219 4.70898 1.04883 4.93359 1.37598 4.93359H7.40625L8.46094 4.89453L7.04492 6.15918L5.94629 7.27246C5.84863 7.37012 5.78516 7.50195 5.78516 7.6582C5.78516 7.95605 6.00977 8.17578 6.31738 8.17578Z",
    fill: "#E5E4EC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRejoinLive);
export default __webpack_public_path__ + "static/media/icon-rejoin-live.881927786746ada069e16468d073b2a6.svg";
export { ForwardRef as ReactComponent };